module.exports = __webpack_public_path__ + "static/img/16b.b4638fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/16b.jpg
// module id = dfVa
// module chunks = 0